/* California Headstone Co. — custom header behavior.
   Uses document-level event delegation so it works regardless of when/how
   Horizon renders or morphs the header section (inline scripts in sections
   don't reliably execute under Horizon's hydration). */
(function () {
  if (window.__chHeaderInit) return;
  window.__chHeaderInit = true;

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.toggle === 'function') {
      drawer.toggle();
      return;
    }
    // The <theme-drawer> element may not be upgraded yet — wait for it, then open.
    if (window.customElements && customElements.whenDefined) {
      var settled = false;
      customElements.whenDefined('theme-drawer').then(function () {
        settled = true;
        var d = document.getElementById('cart-drawer');
        if (d && typeof d.toggle === 'function') { d.toggle(); }
        else { window.location.href = '/cart'; }
      });
      // Fallback if the drawer never initializes.
      setTimeout(function () { if (!settled) window.location.href = '/cart'; }, 1500);
      return;
    }
    window.location.href = '/cart';
  }

  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('[data-ch-cart-toggle]');
    if (cartBtn) {
      e.preventDefault();
      openCartDrawer();
      return;
    }
    var menuBtn = e.target.closest('[data-ch-menu-toggle]');
    if (menuBtn) {
      var header = menuBtn.closest('[data-ch-header]');
      var panel = header && header.querySelector('[data-ch-mobile-menu]');
      if (panel) panel.classList.toggle('ch-open');
    }
  });
})();
